import { prettyNum } from '@iqueue/ui-kit'
import { t } from '../hooks/useTranslate'

export default function humanizeGasVolume(volume) {
  let i = 0
  let fixed = 0

  while (volume > 100000) {
    volume = volume / 10000
    i++
  }

  return {
    value: prettyNum(volume, 10, {
      delimiter: ' ',
      separator: '.',
      fixed,
    }),
    dimension: ' ' + t(`dimension.VOLUME.humanize.${ i }`),
  }
}
